// import React from "react";
// import TestimonialCard from "./TestimonialCard";
// import { TestimonialsGridProps } from "@/models/testimonials/TestimonialGrid";

// const TestimonialsGrid = ({ comments }: TestimonialsGridProps) => {
//   const columns = 3;

//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8 md:auto-rows-fr">
//       {Array.from({ length: columns }).map((_, colIndex) => (
//         <div key={colIndex} className="space-y-6">
//           {comments
//             .filter((_, index) => index % columns === colIndex)
//             .map((comment, index) => (
//               <TestimonialCard
//                 key={colIndex + index * columns}
//                 comment={comment}
//               />
//             ))}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default TestimonialsGrid;

import React from "react";
import TestimonialCard from "../TestimonialCard";
import { TestimonialsGridProps } from "@/models/ITestimonial";
import { Button } from "../../../components/ui/button";

const TestimonialsGrid = ({ comments }: TestimonialsGridProps) => {
  const [columns, setColumns] = React.useState(3);
  const [showAll, setShowAll] = React.useState(false);

  React.useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth < 640) {
        setColumns(1);
      } else if (window.innerWidth < 1024) {
        setColumns(2);
      } else {
        setColumns(3);
      }
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);
    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  const displayedComments =
    showAll || comments.length <= 3 ? comments : comments.slice(0, 3);
  const hasMoreCards = comments.length > 3;

  return (
    <>
      <div
        className="grid gap-6 mt-8"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div key={colIndex} className="space-y-6">
            {displayedComments
              .filter((_, index) => index % columns === colIndex)
              .map((comment, index) => (
                <TestimonialCard
                  key={colIndex + index * columns}
                  comment={comment}
                />
              ))}
          </div>
        ))}
      </div>

      {hasMoreCards && !showAll && (
        <div className="flex justify-center mt-8">
          <Button variant="outline" onClick={() => setShowAll(true)}>
            Load More
          </Button>
        </div>
      )}
    </>
  );
};

export default TestimonialsGrid;
